import {Box, CircularProgress} from '@mui/material'

export const ModalCircularProgress = (): JSX.Element => (
  <Box
    sx={{
      height: '300px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
    <CircularProgress />
  </Box>
)
